module.exports = __webpack_public_path__ + "static/media/PM118.8cfa21a2.png";